import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { loadSites } from '../store/slices/sitesSlice';
import SiteCard from '../components/SiteCard';

export default function Dashboard() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { sites, loading, error } = useAppSelector((state) => state.sites);

  useEffect(() => {
    dispatch(loadSites());
  }, [dispatch]);

  const handleSiteClick = (siteId: string) => {
    navigate(`/sites/${siteId}`);
  };

  if (loading && sites.length === 0) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Loading sites...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#ef4444' }}>
        <p>Error: {error}</p>
        <button
          onClick={() => dispatch(loadSites())}
          style={{
            marginTop: '1rem',
            padding: '0.5rem 1rem',
            backgroundColor: '#3b82f6',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.75rem', fontWeight: 600 }}>Site Capacity Dashboard</h1>
        <p style={{ margin: '0.5rem 0 0', color: '#666' }}>
          Overview of all manufacturing sites and their capacity utilization.
        </p>
      </div>

      {sites.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', backgroundColor: '#fff', borderRadius: '8px' }}>
          <p style={{ color: '#666' }}>No sites found. Start DynamoDB and run the seed script.</p>
          <code style={{ display: 'block', marginTop: '1rem', padding: '1rem', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
            docker-compose up -d && npm run seed --workspace=@site-capacity-planner/backend
          </code>
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '1.5rem',
          }}
        >
          {sites.map((site) => (
            <SiteCard
              key={site.siteId}
              site={site}
              onClick={() => handleSiteClick(site.siteId)}
            />
          ))}
        </div>
      )}

      <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#f0f9ff', borderRadius: '8px' }}>
        <p style={{ margin: 0, fontSize: '0.875rem', color: '#0369a1' }}>
          <strong>Legend:</strong>{' '}
          <span style={{ color: '#22c55e' }}>●</span> Open Capacity (&lt;70%){' '}
          <span style={{ color: '#3b82f6' }}>●</span> Normal (70-95%){' '}
          <span style={{ color: '#ef4444' }}>●</span> Near Full (&gt;95%)
        </p>
      </div>
    </div>
  );
}
